import { Action, configureStore, ThunkDispatch } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { useDispatch } from "react-redux";
import blenderApi from "./apis/blenderApi";
import historicalDataApi from "./apis/historicalDataApi";
import authSlice from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [blenderApi.reducerPath]: blenderApi.reducer,
    [historicalDataApi.reducerPath]: historicalDataApi.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware()
    .concat(
      blenderApi.middleware,
      historicalDataApi.middleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, Action>;
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
